var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/afterpay-info/step3-small.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg class=\"i-afterpay-process-icon\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" x=\"0px\" y=\"0px\"\n     viewBox=\"0 0 100 100\" style=\"enable-background:new 0 0 100 100;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n    .st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n</style>\n<path class=\"st0\" d=\"M74.5,14.7v70.6c0,2.3-1.9,4.2-4.2,4.2H29.7c-2.3,0-4.2-1.9-4.2-4.2V14.7c0-2.3,1.9-4.2,4.2-4.2h40.6\n    C72.6,10.5,74.5,12.4,74.5,14.7z\"/>\n<polyline class=\"st0\" points=\"45.5,67.1 49.9,71.4 58.4,63 \"/>\n<line class=\"st0\" x1=\"25.5\" y1=\"19.5\" x2=\"74.5\" y2=\"19.5\"/>\n<line class=\"st0\" x1=\"25.5\" y1=\"84.4\" x2=\"74.5\" y2=\"84.4\"/>\n<line class=\"st0\" x1=\"45.5\" y1=\"15.5\" x2=\"54.5\" y2=\"15.5\"/>\n<circle class=\"st0\" cx=\"50\" cy=\"43\" r=\"14.5\"/>\n<circle class=\"st0\" cx=\"50\" cy=\"38.8\" r=\"6.1\"/>\n<path class=\"st0\" d=\"M39.9,53.5c1.1-3.5,4.4-5.8,8-5.8h4.2c3.6,0,6.9,2.3,8,5.8\"/>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/afterpay-info/step3-small.j2"] , dependencies)